import axios from 'axios';
import { getDeviceId } from './deviceId';
const api = axios.create({ baseURL: '/api' });
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers['X-Xiaoying-Device-ID'] = getDeviceId();
  return config;
});
api.interceptors.response.use(res => res, err => {
  const url = err.config?.url ?? '';
  const handlesOwnAuthNavigation = ['/auth/login', '/auth/register', '/auth/logout'].includes(url)
    || url.startsWith('/auth/sms/');
  if (err.response?.status === 401 && !handlesOwnAuthNavigation) {
    localStorage.removeItem('token');
    window.location.href = '/login';
  }
  return Promise.reject(err);
});
export default api;
